export default {
  // PDF Header
  pdfTitle: 'Request for Quotation (RFQ)',
  rfqNumber: 'RFQ No',
  
  // Sections
  projectInfo: 'Project Information',
  vendorInfo: 'Vendor Information',
  basicInfo: 'Basic RFQ Information',
  selectedSections: 'Selected Sections and Services',
  additionalServices: 'Additional Service and Product Requests',
  technicalSpecs: 'Technical Specifications',
  deliveryInstallation: 'Delivery and Installation',
  specialNotes: 'Special Notes and Constraints',
  vendorProposal: 'Vendor Proposal',
  deadlineContact: 'Deadline and Contact Information',
  
  // Project Info Fields
  projectName: 'Project Name',
  projectLocation: 'Project Location',
  projectType: 'Project Type',
  projectDescription: 'Project Description',
  
  // Vendor Info Fields
  vendorName: 'Vendor Name',
  vendorCompany: 'Company',
  vendorEmail: 'Email',
  vendorPhone: 'Phone',
  
  // Basic Info Fields
  status: 'Status',
  priority: 'Priority',
  budget: 'Budget',
  currency: 'Currency',
  createdDate: 'Created Date',
  
  // Status Values
  statusDraft: 'Draft',
  statusSent: 'Sent',
  statusReceived: 'Received',
  statusUnderReview: 'Under Review',
  statusApproved: 'Approved',
  statusRejected: 'Rejected',
  
  // Priority Values
  priorityLow: 'Low',
  priorityMedium: 'Medium',
  priorityHigh: 'High',
  priorityUrgent: 'Urgent',
  
  // Sections and Services
  section: 'Section',
  services: 'Services',
  
  // Additional Services
  serviceProduct: 'Service/Product',
  quantity: 'Quantity',
  unit: 'Unit',
  specifications: 'Specifications',
  
  // Technical Specs
  specName: 'Specification',
  specValue: 'Value',
  
  // Delivery & Installation
  deliveryAddress: 'Delivery Address',
  deliveryDate: 'Delivery Date',
  installationRequired: 'Installation Required?',
  installationNotes: 'Installation Notes',
  yes: 'Yes',
  no: 'No',
  
  // Special Notes
  constraints: 'Constraints',
  specialRequirements: 'Special Requirements',
  
  // Vendor Proposal
  proposalAmount: 'Proposal Amount',
  proposalNotes: 'Proposal Notes',
  proposalDate: 'Proposal Date',
  
  // Deadline & Contact
  submissionDeadline: 'Submission Deadline',
  contactPerson: 'Contact Person',
  contactEmail: 'Email Address',
  contactPhone: 'Phone Number',
  
  // Common
  notSpecified: 'Not Specified',
  noData: 'No data',
  
  // Buttons
  edit: 'Edit',
  preview: 'Preview',
  downloadPDF: 'Download PDF',
  generating: 'Generating...',
  
  // Language Selection
  turkish: 'Turkish',
  english: 'English',
  selectLanguage: 'Select Language'
};